<template>
	<div id="agecharts"
	style="height: 300px; margin:0 auto">
</div>
</template>

<script>
import echarts from 'echarts'
export default {
name: 'agecharts',
data () {
	return {
		age:[]
	}
},
mounted () {
	this.init()
},
methods: {
	init(pk){
		let that = this
		var url = '/case/dashboard/age/'
		if(pk){
			url = url + pk + '/'
		}
		this.$http.get(url).then(res => {
			if(res.data.code === 1){
				that.age = res.data.data
				that.drawBar()
			}
		})
	},
	drawBar () {
		let myChart = echarts.init(document.getElementById('agecharts'))
    // 绘制图表
    let option =  {
			color: ['rgb(128, 176, 210)','rgb(250, 153, 141)'],
			tooltip: {
				trigger: 'axis'
			},
			grid: {
				left: '3%',
				right: '3.5%',
				bottom: '2%',
				top:'14%',
				containLabel: true
			},
			legend: {
				data: ['年龄']
			},
			xAxis:  {
				type: 'category',
				data: ['18-29','30-39','40-49','50-59','60-69','70~']
			},
			yAxis: {
				type: 'value',
			},
			series: [
			{
				name: '年龄',
				type: 'bar',
				data: this.age,
				label:{
					normal:{
						show:true,
						position:'top',
						textStyle:{
							fontSize:14
						}
					}
				},                        
				markLine: {
					data: [
					{type: 'average', name: '平均值'},
					]
				}
			},
			]
    };
    myChart.setOption(option)
  },
}
};
</script>
